// extracted by mini-css-extract-plugin
module.exports = {"body":"about-module--body--2t1Cc","profile":"about-module--profile--1cPDy","headline":"about-module--headline--ZUnTa","underline":"about-module--underline--6OmQ7"};